import { LUNG_FINDINGS, THORACIC_IMPRESSION } from "../groups/thoracic";
import { option, type UsWorksheetDefinition } from "../us-fields";

const THORACIC_INDICATIONS = [
  option("shortness_of_breath", "Shortness of breath"),
  option("chest_pain", "Chest pain"),
  option("trauma", "Trauma"),
  option("hypotension", "Hypotension"),
  option("absent_breath_sounds", "Absent breath sounds"),
  option("wheezing", "Wheezing"),
  option("hypoxia", "Hypoxia"),
  option("cough", "Cough"),
  option("fever", "Fever"),
];

export const US_THORACIC: UsWorksheetDefinition = {
  examType: "us_thoracic",
  version: 1,
  indications: THORACIC_INDICATIONS,
  sections: [
    {
      id: "thoracic_lung",
      label: "lung",
      role: "findings",
      technicallyLimited: true,
      repeatPerSide: ["right", "left"],
      fields: LUNG_FINDINGS,
    },
    {
      id: "thoracic_impression",
      label: "Impression",
      role: "impression",
      fields: [THORACIC_IMPRESSION],
    },
  ],
  normalImpressions: [
    {
      sectionId: "thoracic_impression",
      value: "normal_thoracic",
    },
  ],
  billing: {
    codes: [{ cpt: "76604", label: "Chest ultrasound", preTick: true }],
  },
};
